import { Link } from "react-router-dom";
import React from "react";
export default function Thankyou() {
    return (
        <>
            <section className="thanku-area">
                <div className="container">
                    <div className="row justify-content-between">
                        <div className="col-lg-12 col-md-12">
                            <div className="thanku-contact">
                                <div>
                                    <label>Get In Touch</label>
                                    <ul>
                                        <li>
                                            <div><img src="/assets/images/thanku-icon-1.webp" alt="icon" /></div>
                                            <Link to="tel:9056260016">9056260016</Link>
                                        </li>
                                        <li>
                                            <div><img src="/assets/images/thanku-icon-2.webp" alt="icon" /></div>
                                            <Link to="mailto:info@catalyze.co.in">info@catalyze.co.in</Link>
                                        </li>
                                        <li>
                                            <div><img src="/assets/images/thanku-icon-3.webp" alt="icon" /></div>
                                            <Link to="/">www.catalyze.co.in</Link>
                                        </li>
                                    </ul>
                                </div>
                                <span className="sub-title"><img src="/assets/images/thnku-whitestar.webp" alt="star" />Catalyze</span>
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-12">
                            <div className="thanku-bottom">
                                <p>© 2026 All rights reserved by Catalyze</p>
                                <h1 className="heading">Thank <span>You</span></h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}